import { render } from "./MultipleChoiceResultRow.vue?vue&type=template&id=1a2b4330&scoped=true&ts=true"
import script from "./MultipleChoiceResultRow.vue?vue&type=script&lang=ts"
export * from "./MultipleChoiceResultRow.vue?vue&type=script&lang=ts"

import "./MultipleChoiceResultRow.vue?vue&type=style&index=0&id=1a2b4330&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2b4330"]])

export default __exports__